import { ValidationRules } from "aurelia-validation";

import { ICreateService } from "../interfaces/i-schedule";

export class NewService implements ICreateService {
    public ScheduleDate: string = "";
    public patient: { name: string; value: string } | null = null;
    public bereavedContacts: { name: string; value: string }[] = [];
    public bereavementService: number[] = [];
    public assignedTo: { name: string; value: string } | null = null;

    public constructor(data?: ICreateService) {
        if (data) {
            Object.assign(this, data);
        }
        this.initValidation();
    }

    private initValidation() {
        ValidationRules.ensure((service: ICreateService) => service.ScheduleDate)
            .required()
            .withMessage("Schedule Date is required.")
            .on(this);
    }
}
